import React from "react";
import { Box } from "@mui/material";
import SatisfactionToggle from "../../../../components/GridViewToggle/SurveyReportSatisfactionToggle";
import PatientSurveyDetailsTable from "../../../../pages/reports-module/patient-survey-report/patient-survey-details-table";

const DetailsView = ({
    detailsMode,
    setDetailsMode,
    detailsRows,
    detailsLoading,
    detailsPage,
    setDetailsPage,
    detailsPageSize,
    setDetailsPageSize,
    detailsTotal,
    styles
}) => {
    return (
        <Box className={styles.detailsView} sx={{ mt: 1, mb: 6, overflow: 'visible' }}>
            <Box className={styles.detailsHeaderRow}>
                <Box className={styles.detailsTitleWrap}>
                    <div className={styles.detailsTitle}>
                        {detailsMode === "high" ? (
                            <>High Satisfaction (4&ndash;5 stars)</>
                        ) : (
                            <>Low Satisfaction (1&ndash;3 stars)</>
                        )}
                    </div>

                    <div className={styles.detailsSubtitle}>
                        {detailsMode === "high"
                            ? "Satisfied customers and excellent service experiences"
                            : "Customer complaints and areas requiring attention"}
                    </div>
                </Box>

                <SatisfactionToggle
                    mode={detailsMode}
                    onChange={(m) => {
                        setDetailsMode(m);
                        setDetailsPage(0);
                    }}
                    size="small"
                />
            </Box>

            <PatientSurveyDetailsTable
                rows={detailsRows}
                mode={detailsMode}
                loading={detailsLoading}
                page={detailsPage}
                pageSize={detailsPageSize}
                total={detailsTotal}
                onPageChange={(p) => setDetailsPage(p)}
                onPageSizeChange={(ps) => {
                    setDetailsPageSize(ps);
                    setDetailsPage(0);
                }}
            />
        </Box>
    );
};

export default DetailsView;
